import { createContext, useContext } from 'react';
import type { LoginMode } from '@wix/cli-core-definitions';

const LoginModeContext = createContext<LoginMode | undefined>(undefined);
export const LoginModeProvider = LoginModeContext.Provider;

export function useLoginModeContext() {
  return useContext(LoginModeContext);
}
